// index banner swiper
const path = location.pathname;
const gShipperPointMul = 3; // 带有Dropshipper默认添加积分倍数
const gDefPointMul = 10; // 默认添加积分倍数

/**
 * 格式化会员积分文案显示
 * @param {当前金额} currentPrice 
 * @returns html代码
 */
function formatMemberHtml(currentPrice) {
  let promptCopy = '';
  var memberPoint = 0;
  if (email) {
    // 登录之后带有标签
    if (customerTags.includes('Dropshipper')) {
      memberPoint = currentPrice * gShipperPointMul;
    } else {
      memberPoint = currentPrice * gDefPointMul;
    }
    // promptCopy = `<b>Double Points Wednesday🎉</b> <br/>-->Reward: <span style="color: #d5672d;" class="j-member-point">${ Math.floor(memberPoint) }</span> SONGMICS HOME points >`
    promptCopy =`<b>Double Points Wednesday🎉</b> <br/>Earn up to 【<b style="color: #d5672d;" class="j-member-point">${ Math.floor(memberPoint) }</b>】 points calculated at checkout. `
  } else {
    memberPoint = currentPrice * gDefPointMul;
    // 没有登录 
    // promptCopy =`<!--<b>Double Points Wednesday🎉</b> <br/>-->Join <a href="https://songmicshome.co.uk/account/login" onclick="commonGtmEvent('Member', 'Login', 'Listing')" style="text-decoration: underline;" >SONGMICS HOME CLUB</a> and earn up to <span style="color: #d5672d;" class="j-member-point">${ Math.floor(memberPoint) }</span> points for this purchase`
    // Earn 【490】 Points. Sign In/Join Now > 
    promptCopy =` <b>Double Points Wednesday🎉</b> <br/>Earn up to【<b style="color: #d5672d;" class="j-member-point">${ Math.floor(memberPoint) }</b>】 points calculated at checkout. <a id="click-register-box" onclick="commonGtmEvent('Member', 'Login', 'Listing')" style="text-decoration: underline;">Sign In/Join Now -></a>`
  }

  var _tempHtml = `<div><img src="https://cdn.shopify.com/s/files/1/0626/8030/1758/files/Group_6529.svg?v=1718179594" style="width: 16px;"> ${promptCopy}
    <div class="box-help-cart" onclick="memberModal('The SONGMICS HOME points will be added to your account after your order status changes to fulfilled. Every 1000 Points you accumulate is worth £10！')">
      <svg t="1673843336793" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1371" width="16" height="16"><path d="M1024 512c0 282.624-229.376 512-512 512S0 794.624 0 512 229.376 0 512 0s512 229.376 512 512z m-510.464 209.408c-23.552 0-43.008 19.456-43.008 43.008v9.728c0 23.552 19.456 42.496 43.008 42.496 23.552 0 43.008-18.944 43.008-42.496v-9.728c0-23.552-19.456-43.008-43.008-43.008z m10.24-481.792c-56.32-1.024-99.84 13.312-129.536 42.496-32.256 31.744-48.64 81.408-48.64 147.456v0.512c1.024 10.752 10.752 30.72 37.376 30.72 26.624 0 35.328-20.48 35.84-31.232-1.024-40.96 8.192-71.168 27.136-89.6 17.92-17.408 45.568-25.6 81.92-23.552 49.664 5.632 74.752 32.768 76.8 82.944-3.584 22.528-23.04 52.224-57.344 88.576C500.224 536.576 476.16 580.608 476.16 619.52v39.424c1.536 9.728 10.752 27.648 35.328 27.648 24.064 0 33.792-17.92 35.328-27.648v-27.648c0-29.696 22.016-66.56 66.048-108.544 48.128-44.032 72.192-85.504 72.192-123.392-4.608-101.888-58.368-155.648-161.28-159.744z" p-id="1372"></path></svg>
    </div>`;
    
    $("body").on("click","#click-register-box",function(){
      window.open('/account/register', '_blank');
})
  return _tempHtml;
}

function memberModal(content) {
  // 创建模态窗口元素
  var modal = document.createElement('div');
  modal.id = 'modal-member';
  modal.innerHTML = `
      <div id="modal-member-content">
          <span id="modal-member-close">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 42 42" fill="none">
            <path d="M1 1L41 41" stroke="black" stroke-width="2"></path>
            <path d="M41 1L1 41" stroke="black" stroke-width="2"></path>
            </svg>
          </span>
          <p>${content}</p>
      </div>
  `;

  // 定义模态窗口样式
  var style = document.createElement('style');
  style.innerHTML = `
      #modal-member {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgb(0 0 0 / 20%);
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: center;
      }
      #modal-member-content {
          width: 500px;
          background: #fff;
          padding: 60px 30px;
          box-sizing: content-box;
          position: relative;
      }
      #modal-member-content p {
          font-size: 16px;
          line-height: 22px;
      }
      #modal-member-close {
          cursor: pointer;
          position: absolute;
          right: 20px;
          top: 20px;
      }
      @media (max-width:768px) {
        #modal-member-content {
            width: 70%;
        }
        #modal-member-content p {
            font-size: 14px;
        }
      }
  `;

  // 添加模态窗口和样式到页面
  document.body.appendChild(modal);
  document.head.appendChild(style);

  // 获取关闭按钮元素并添加点击事件
  var close = document.getElementById('modal-member-close');
  close.onclick = function() {
      modal.remove();
  }
}

//  shadowRoot Append style
let timeNum = 0;
let timer;
timer = setInterval(() => {
  let picsWrap = document.querySelector(".needsclick");
  timeNum++;
  if (picsWrap) {
    clearInterval(timer);
    let style = document.createElement("style");
    style.innerHTML = `
      .filters{
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
      }
      .filters .btn-filter{
        font-size:16px;
      }
      .filters .btn-filter+.btn-filter{
            border: none;
      }
      .filters .btn-filter{
        transition: all .5s;
      }
      .filters .btn-filter:hover{
            background: #F5F5F5;
            border-radius: 5px;
      }
      .filters .btn-filter:active,
      .filters .btn-filter:focus{
            background: #F5F5F5;
            border-radius: 5px;
            color:#CB652F;
      }
      .btn-load-more.btn_style_1{
            padding: 12px 20px;
            border: 1px solid #222222;
            margin-top:100px;
            margin-bottom: 0;
      }
      
      .filters{
        overflow-x: auto;
  }
      @media (max-width:768px) {
            .filters{
                  overflow-x: auto;
            }
            .filters .btn-filter{
               font-size: 14px;
               padding: 5px 10px;
               margin-right: 10px;
               background: #F5F5F5;
               border-radius: 5px;
               
            }
            .upload-widget{
                  display: none;
            }
            .btn-load-more.btn_style_1{
                  margin-top: 35px;
            }
      }
      `;
    picsWrap.shadowRoot.appendChild(style);
    return;
  } else if (timeNum == 10) {
    // Only 10 times are queried, and if the element is not queried after ten times, the style is not appended
    clearInterval(timer);
  }
}, 2000);

$(document).on("click", ".np_sidebar .widget-title", function () {
  if ($(this).next().is(":visible")) {
    $(this).addClass("on");
    $(this).next().slideUp();
  } else {
    $(this).removeClass("on");
    $(this).next().slideDown();
  }
});

function isMobile() {
  return (/Android|iPhone|iPad|iPod|BlackBerry/i).test(navigator.userAgent || navigator.vendor || window.opera);
}

/**
 * gtm 用户事件添加
 * commonGtmEvent
 * category 类别
 * operating 操作
 * label 标签
 */
function commonGtmEvent(category, operating, label) {
  dataLayer.push({ event: 'custom', category, operating, label });
}

$(function () {
  // 添加搜索热词
  const searchList = [
    { name: 'coffee table', value: '/collections/coffee-tables?ref=search' },
    { name: 'jewellery box', value: '/collections/jewellery-boxes?ref=search' },
    { name: 'rubbish bins', value: '/collections/rubbish-bins?ref=search' },
    { name: 'computer desk', value: '/collections/computer-desks?ref=search' },
    { name: 'office chair', value: '/collections/executive-office-chairs?ref=search' },
    { name: 'bookcase', value: '/collections/bookcases?ref=search' },
    { name: 'tv stand', value: '/collections/tv-stands?ref=search' },
    { name: 'shoe rack', value: '/collections/shoe-storage?ref=search' },
    { name: 'cat tree', value: '/collections/cat-trees?ref=search' },
    { name: 'vasagle furniture', value: '/pages/vasagle-home-accent-furniture?ref=search' },
    { name: 'songmics furniture', value: '/pages/songmics-beyond-basic?ref=search' },
    { name: 'feandrea', value: '/pages/feandrea-pet-supplies?ref=search' }
  ]
  var _htmlArr = '';
  for (let index = 0; index < searchList.length; index++) {
    _htmlArr += `<li>
          <a href="${searchList[index].value}" >
            ${searchList[index].name}
          </a>
        </li>`;
  }
  $('.history-hot-words ul').html(_htmlArr);

   
  // 初始化 弹出框订阅
  $('body').on("click", ".js_pop_newsletter", function () {
    var $parent = $(this).closest('.js_mail_agree');
    var email = $parent.find('.j_newsletter_email').val();
    var agreeFalg = $parent.find('.css_agree_ck').is(':checked');
    console.log(email, '-------', );
    if (email !== '' && agreeFalg) {
      contactShopify({ email }).then(function (res) {
        var $resHtml = $($.parseHTML(res));
        var msgTipHtml = $resHtml.find('.j-contact-response')[0];
         var errArr = $resHtml.find('.j-contact-error');
        if (errArr.length > 0) {
        } else {
          console.log('su');
          // 看看是否需要关闭弹出框
        }
        $parent.find('.j-contact-response').html(msgTipHtml);
      }).catch(function (error) {
          // eslint-disable-next-line no-console
          console.log(error);
          $parent.submit();
      });
    }
  });

  
  // 添加移动端导航轮播
  if (isMobile()) {
    let _timeNum = 0;
    let _timer;
    _timer = setInterval(() => {
      let flag = $('.myMHeaderSwiper').length
      if (flag > 0) {
        let _swiper = new Swiper(".myMHeaderSwiper", {
          slidesPerView: 'auto',
          loop: true,
          loopedSlides: 2,
          centeredSlides: true,
          on: {
            slideChangeTransitionEnd: function (v) {
              let index = $('.myMHeaderSwiper .swiper-slide-active').attr('data-swiper-slide-index');
              $('#nt_menu_canvas .shopify-section-mb_nav_1').hide();
              $('#nt_menu_canvas .shopify-section-mb_nav_2').hide();
              $('#nt_menu_canvas .shopify-section-mb_nav_3').hide();
              $('#nt_menu_canvas #shopify-section-mb_nav_js').hide();
              console.log(index);
              switch (index) {
                case '0':
                  $('#nt_menu_canvas #shopify-section-mb_nav_js').fadeIn(800);
                  break;
                case '1':
                  $('#nt_menu_canvas .shopify-section-mb_nav_1').fadeIn(800);
                  break;
                case '2':
                  $('#nt_menu_canvas .shopify-section-mb_nav_2').fadeIn(800);
                  break;
                case '3':
                  $('#nt_menu_canvas .shopify-section-mb_nav_3').fadeIn(800);
                  break;
              }
              console.log('xxxx:' + index);
              //  根据索引显示不同的块
            }
          }
        });

        // 添加导航事件监听
        $("#menu_mb_ul .abs-comeback").on('click', function (event) {
          console.info("Submit button is clicked!");
          $(this).parents('.menu-item').removeClass('nt_opended')
          // event.preventDefault();
        });
        $('#menu_mb_ul').on('click', '.j-ment-list', function (e) {
          console.info("sub-sub- button is clicked!", e);
          $(this).parents('.sub-list-item').find('.sub-sub-item').addClass('sub-active')
          $(this).parents('.menu-item').removeClass('nt_opended').addClass('nt_opended2')
        });
        // 三级返回
        $('#menu_mb_ul').on('click', '.j-sub-comeback', function () {
          console.info("xxxxxx12 button is clicked!");
          $(this).parents('.menu-item').removeClass('nt_opended2').addClass('nt_opended').find('.sub-sub-item').removeClass('sub-active')
        });
       
        $('.history-hot-words ul').html(_htmlArr); 
        clearInterval(_timer);
      }
      _timeNum++;
      if (_timeNum > 10) {
        clearInterval(_timer);
      }
    }, 1000);
  }
  // 改变窗口大小时重新设置 rem
  setTimeout(function () {
    window.onresize = function () {
      console.log('-resize')
      setRem()
    };
  }, 10000)

  if (path == "/") {
    var indexBannerSwiper = new Swiper(".swiper_index_banner", {
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
      }
    });
    urlFormatRef('home');
  }
  
  // 新首页配置ref
  if (path == "/pages/songmics-new") {
    urlFormatRef('homenew');
  }


  if (path.includes("/collections")) {
    var arrivalsSwiper = new Swiper(".arrivals_swiper", {
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    var swiper = new Swiper(".categorySwiper", {
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true
      },
      slidesPerView: isMobile() ? 'auto' : 'auto',
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      spaceBetween: 10
    });

    formatPrImg();
    setTimeout(function() {
      formatPrImg();
    }, 2000)
  }
  if (path.includes("/blogs")) {
    var articleSwiper = new Swiper(".article_slideshow", {
      slidesPerView: 1.5,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
    });
  }

  if (path.includes("/products")) {
    setTimeout(function() {
      productMember();
    }, 1000)
    $(function(){
      // 注册拷贝方法
      $("#shopify-section-pr_summary .discount-info .copy").on('click', function (event) {
        console.log($(this).attr('text'));
        copyTxt($(this).attr('text'))
        // color: #D4672C;
        $(this).addClass("copied").text('Copied!');
        // event.preventDefault();
        let that = this;
        setTimeout(function(){
          $(that).removeClass("copied").text('Copy Code');
        }, 3000)
      });
    });
  }

  // 产品图片格式化图片，方便移动上去切换
  setTimeout(function() {
    formatPrImg();
  }, 2000)
  
})


/**
 *  拷贝方法
 * @param {要复制的文本} text 
 */
function copyTxt(text) {
  if (navigator.clipboard) {
      // clipboard api 复制
      navigator.clipboard.writeText(text);
  } else {
      var textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      // 隐藏此输入框
      textarea.style.position = 'fixed';
      textarea.style.clip = 'rect(0 0 0 0)';
      textarea.style.top = '10px';
      // 赋值
      textarea.value = text;
      // 选中
      textarea.select();
      // 复制
      document.execCommand('copy', true);
      // 移除输入框
      document.body.removeChild(textarea);
  }
}


// 设置 rem 函数
function setRem(num) {
  //  PC端
  console.log('非移动设备')
  // 基准大小
  baseSize = 100;
  let basePc = baseSize / num; // 表示1920的设计图,使用100PX的默认值
  let vW = window.innerWidth; // 当前窗口的宽度
  let vH = window.innerHeight; // 当前窗口的高度
  // 非正常屏幕下的尺寸换算
  // let dueH = vW * 1080 / 1920
  // if (vH < dueH) { // 当前屏幕高度小于应有的屏幕高度，就需要根据当前屏幕高度重新计算屏幕宽度
  //   vW = vH * 1920 /1080
  // }
  // 大屏幕以1920 为准
  if (vW > 1920) {
    vW = 1920;
  }
  let rem = vW * basePc; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应font-size值

  // 处理特殊屏幕放大处理
  if (vW == 1280 && window.devicePixelRatio == 1.5) {
    rem = 95;
  }

  document.documentElement.style.fontSize = rem + "px";
}
// 初始化
if (!isMobile()) {
  setRem(1920);
} else {
  setRem(750);
}


/**
 * 
 * @param {html 反转义} text 
 * @returns 
 */
function HTMLDecode(text) {
  var temp = document.createElement("div");
  temp.innerHTML = text;
  var output = temp.innerText || temp.textContent;
  temp = null;
  return output;
}

/**
 * 处理分类页面移动上去图片显示问题
 */
function formatPrImg() {
  setTimeout(function() {
    $('.j_pr_hover_img').each(function(){
      let ths = $(this).attr('data-image');
      let imageSrc= formatImage(JSON.parse(ths)[1].src, 600, 600)
      $(this).css('background-image', `url(${imageSrc})`)
    })
  }, 3000)
}

/**
 * 会员积分-产品界面-
 */
function productMember() {
  // 积分显示文案
  // 增加会员积分文案
  var currentPrice = $('#price_ppr ins').text() == '' ? $('#price_ppr').text() : $('#price_ppr ins').text();
  currentPrice = Math.floor(currentPrice.substr(1));
  var tempHtml = formatMemberHtml(currentPrice);
  $('.points-block').append(tempHtml)
}




/**
 * 格式化图片链接
 * @param fileName 文件名
 * @param width 图片宽度
 * @param type 高度(number, 默认=width) | 图片类型（string, 默认：'/fit-in'）
 */
function formatImage (fileName, width, type)  {
  if (!fileName) return '';
  if (fileName.startsWith('http')) return fileName;
  const country = 'uk';
  let domain = 'https://static.songmics.com';
  switch (country) {
    case 'uk':
      domain = 'https://static.songmics.co.uk';
      break;
    case 'de':
      domain = 'https://static.songmics.de';
      break;
    case 'es':
      domain = 'https://static.songmics.es';
      break;
    case 'fr':
      domain = 'https://static.songmics.fr';
      break;
    case 'it':
      domain = 'https://static.songmics.it';
      break;
  }

  let height = width;
  let fitType = '';
  if (type) {
    if (typeof type === 'number') {
      height = type;
    }
  } else {
    fitType = '/fit-in';
  }
  if (width && width > 0) {
    domain += `${fitType}/${width}x${height}`;
  }
  if (fileName.startsWith('/')) {
    return domain + fileName;
  }
  return domain + '/' + fileName;
};
/**
 * 格式化视频链接
 * @param fileName 文件名
 * @param width 图片宽度
 * @param type 高度(number, 默认=width) | 图片类型（string, 默认：'/fit-in'）
 */
function formatVideo (fileName, width, type)  {
  if (!fileName) return '';
  if (fileName.startsWith('http')) return fileName;
  const country = 'us';
  let domain = 'https://static.songmics.com';
  switch (country) {
    case 'uk':
      domain = 'https://static.songmics.co.uk';
      break;
    case 'de':
      domain = 'https://static.songmics.de';
      break;
    case 'es':
      domain = 'https://static.songmics.es';
      break;
    case 'fr':
      domain = 'https://static.songmics.fr';
      break;
    case 'it':
      domain = 'https://static.songmics.it';
      break;
  }

  let height = width;
  let fitType = '';
  if (type) {
    if (typeof type === 'number') {
      height = type;
    }
  } else {
    fitType = '/fit-in';
  }
 
  if (fileName.startsWith('/')) {
    return domain + fileName;
  }
  return domain + '/' + fileName;
};
/**
 * 
 * @desc   url参数转对象
 * @param  {String} url  default: window.location.href
 * @return {Object} 
 */
function parseQueryString(url) {
  url = !url ? window.location.href : url;
  if(url.indexOf('?') === -1) {
      return {};
  }
  var search = url[0] === '?' ? url.substr(1) : url.substring(url.lastIndexOf('?') + 1);
  if (search === '') {
      return {};
  }
  search = search.split('&');
  var query = {};
  for (var i = 0; i < search.length; i++) {
      var pair = search[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}


/**
 * 格式化首页 链接
 * @param {home or newHome} url 
 */
function urlFormatRef(url) {
   // 添加旧首页 推广ref 代码
  setTimeout(function(){
    $('#nt_content a').each(function () {
      var _href = $(this).attr('href');
      if (_href.includes('#') || !_href || _href.includes('ref=')){
         return
      }
       // 添加参数？
      $(this).attr('href', `${_href}${ _href.includes('?')?'&': '?' }ref=${url}`)
    })
  }, 2000);
}

/**
 * 订阅方法
 * @param {邮箱对象} data 
 * @returns 
 */
function contactShopify(data) {
  let result = data
  return new Promise((resolve, reject) => {
      let contactUrl = '/contact'
      let data = {
        'contact[tags]': 'newsletter',
        'contact[email]': result.email,
        // 'contact[phone]': '+441314960905',
        'return_to': 'pages/blank',
        'new_check_agree_': 'on',
          utf8: '✓',
        'form_type': 'customer'
      }
      $.ajax({
          url: contactUrl,
          headers: {
            "accept": "text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7",
            "accept-language": "zh-CN,zh;q=0.9,en;q=0.8",
            "cache-control": "no-cache",
            "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
            "pragma": "no-cache",
          },
          method: 'POST',
          data: data,
          dataType: 'html',
          async: true,
          complete: function (response) {
            console.log(response);
            resolve(response)
          },
          error: function (err) {
            console.log(err);
            reject(err)
          }
      })
  })
}

/**
 * 注册方法
 * @param {登录对象} data 
 * @returns 
 */
function registerShopify(data) {
  let result = data
  return new Promise((resolve, reject) => {
      let loginUrl = '/account'
      let data = {
          'customer[email]': result.account,
          'customer[password]': result.password,
          'customer[accepts_marketing]': result.marketing,
          // 'customer[phone]': '+441314960905',
          'return_to': 'pages/blank',
          form_type: 'create_customer',
      }
      $.ajax({
          url: loginUrl,
          method: 'post',
          data: data,
          dataType: 'html',
          async: false,
          complete: function (response) {
              resolve(response)
          },
          error: function (err) {
            reject(err)
          }
      })
  })
}

function shopiyfLogin(data) {
  let result = data
  return new Promise((resolve, reject) => {
    let loginUrl = '/account/login'
    let data = {
      'customer[email]': result.account,
      'customer[password]': result.password,
      form_type: 'customer_login'
    }
    $.ajax({
      url: loginUrl,
      method: 'post',
      data: data,
      dataType: 'html',
      async: false,
      complete: function (response) {
        resolve(response)
      },
      error: function(err) {
        reject(err)
      }
    })
  })
}


var klaviyo_qv=klaviyo||[];
   
klaviyo_qv.init({
      account: "Y2urcQ",
      platform: "shopify",
      collection_urls: ["/collections/all","/collections","/search","/products/"]   
  });
  klaviyo_qv.enable("backinstock", {
 
      trigger: {    
        product_page_text: "Notify Me When It's Available",
        product_page_class: 'btn',
        product_page_text_align: 'center',
        product_page_margin: '0px',
        replace_anchor: false,
        collection_page_class: 'btn',    
        collection_page_text_align: 'center',    
        collection_page_width: '200px',    
        collection_page_text: "Notify Me When It's Available",    
        collection_page_padding: 'inherit',    
      },
      modal: {
          headline: "{product_name}",
          body_content: "Register to receive a notification when this item comes back in stock.",
          email_field_label: "Email",
          button_label: "Notify Me When It's Available",
          subscription_success_label: "You're in! We'll let you know when it's back.",
          footer_content: '',
          additional_styles: "@import url('https://fonts.googleapis.com/css?family=Poppins');",

          drop_background_color: "#000",
          background_color: "#fff",
          text_color: "#222",
          button_text_color: "#fff",
          button_background_color: "#ed6a00",
          close_button_color: "#ccc",
          error_background_color: "#fcd6d7",
          error_text_color: "#C72E2F",
          success_background_color: "#d3efcd",
          success_text_color: "#1B9500"
      }
}); 

 